import { ColorTypes } from "@omegagrid/core";
import { ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { msg } from "@omegagrid/localize";
import { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import rp from "@reporting/rp-app-host";
import { ExternalResource } from "@reporting/rp-types/ext";

export class ExternalResourcesGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor(private idProject: number) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;

		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 1,
			content: [{
				action: 'delete',
				icon: 'trash',
				title: msg('Delete'),
				color: ColorTypes.Red
			}],
			filter: false
		}, {
			data: 'ord_num',
			header: '#',
			t: 'n',
			z: '0',
			e: true,
			w: 80
		}, {
			data: 'url',
			header: 'URL',
			t: 't',
			e: true,
			w: 500
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		return (await rp.ms('extensions').get<ExternalResource[]>(
			`externalResources/${this.idProject}`,
			this.createRequestParams(filters, {
				fields: ['idz', 'url', 'ord_num'],
				order: [['ord_num', 'asc']],
				count: this.pageSize
			})
		)).map(data => ({ data, props: {idz: data.idz} }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: this.pageSize,
			refreshAfterSave: true,
			// exportTypes : ['csv', 'xlsx'],
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({
			_state: row.state,
			_index: row.index,
			id_custom_page: this.idProject,
			idz: row.props.idz
		}, row.data));
		await rp.ms('extensions').post(`externalResources`, data);
	}

}
